









import { Vue, Component, Prop } from 'vue-property-decorator'

@Component({ name: 'v-link' })
export default class VLink extends Vue {
    @Prop({ type: String, default: '' })
    href!: string

    @Prop({ type: String, default: 'primary' })
    type!: 'primary' | 'grey'
}
